export const animationVerticalMessageBlock = () => {
    let classAnimations = 'ldc-animations-blockMessage';
    let el = document.querySelectorAll('.ldc-message-new');
    if(el.length > 0){
        el = el[el.length -1];
        let addEvent = () => {
            el.classList.remove(classAnimations);
            el.removeEventListener('webkitAnimationEnd', addEvent, false);
        }
        el.classList.add(classAnimations);
        el.addEventListener('webkitAnimationEnd', addEvent, false);
    }
}

export const animationVerticalMessageNone = (el, callbackFunction) => {
    let classAnimations = 'ldc-animations-noneMessage';
    let addEvent = () => {
        callbackFunction.call(this, false);
        el.removeEventListener('webkitAnimationEnd', addEvent, false);
    }
    el.classList.add(classAnimations);
    el.addEventListener('webkitAnimationEnd', addEvent, false);
}

export const animationBlockConfim = () => {
    let classAnimations = 'ldc-animations-blockConfim';
    let el = document.querySelectorAll('.ldc-alert-box');
    if(el.length > 0){
        el = el[el.length -1];
        let dom = el.querySelector('.ldc-alert-content');
        let addEvent = () => {
            dom.classList.remove(classAnimations);
            dom.removeEventListener('webkitAnimationEnd', addEvent, false);
        }
        dom.classList.add(classAnimations);
        dom.addEventListener('webkitAnimationEnd', addEvent, false);
    }
}

export const animationNoneConfim = (el, callbackFunction) => {
    let classAnimations = 'ldc-animations-noneConfim';
    let dom = el.querySelector('.ldc-alert-content');
    let addEvent = () => {
        callbackFunction.call(this, false);
        dom.removeEventListener('webkitAnimationEnd', addEvent, false);
    }
    dom.classList.add(classAnimations);
    el.style.background = '#fff0';
    dom.addEventListener('webkitAnimationEnd', addEvent, false);
}

export const animationBlockModel = (el) => {
    let classAnimations = 'ldc-animations-blockModel';
    let dom = el.querySelector('.ldc-content-mobile');
    let addEvent = () => {
        dom.classList.remove(classAnimations);
        dom.removeEventListener('webkitAnimationEnd', addEvent, false);
    }
    dom.classList.add(classAnimations);
    dom.addEventListener('webkitAnimationEnd', addEvent, false);
}

export const animationNoneModel = (el, callbackFunction) => {
    let classAnimations = 'ldc-animations-noneModel';
    let dom = el.querySelector('.ldc-content-mobile');
    let addEvent = () => {
        el.classList.remove('background-transparent');
        dom.classList.remove(classAnimations)
        callbackFunction.call(this, false);
        dom.removeEventListener('webkitAnimationEnd', addEvent, false);
    }
    dom.classList.add(classAnimations);
    el.classList.add('background-transparent');
    dom.addEventListener('webkitAnimationEnd', addEvent, false);
}